// Kampagnens fremgang: rangtitlen, der vokser med stjernerne, og mærkerne på Danmarkskortet.
// Rent og uden lager, så det kan testes; storage.ts giver tallene.

export interface Rank {
  title: string;
  /** Næste titel og hvor mange stjerner, der mangler, eller null på toppen. */
  next: { title: string; need: number } | null;
}

/** Titlerne og stjernerne, de kræver. Netmester kræver desuden, at finalen er vundet. */
const RANKS: Array<{ title: string; stars: number; finale?: boolean }> = [
  { title: 'Praktikant', stars: 0 },
  { title: 'Montør', stars: 4 },
  { title: 'Vagthavende', stars: 10 },
  { title: 'Driftsleder', stars: 18 },
  { title: 'Systemansvarlig', stars: 28 },
  { title: 'Netmester', stars: 18, finale: true },
];

/** Rangen ud fra alle stjerner på alle sværheder og om kampagnens finale er vundet. */
export function rankOf(stars: number, finaleWon: boolean): Rank {
  if (finaleWon) return { title: 'Netmester', next: null };
  let i = 0;
  for (let j = 0; j < RANKS.length; j++) {
    const r = RANKS[j];
    if (r && !r.finale && stars >= r.stars) i = j;
  }
  const cur = RANKS[i] as { title: string };
  const nxt = RANKS[i + 1];
  if (!nxt || nxt.finale) return { title: cur.title, next: { title: 'Netmester', need: 0 } };
  return { title: cur.title, next: { title: nxt.title, need: nxt.stars - stars } };
}
